document.querySelectorAll('[data-faq-list]').forEach(function (list) {
  var triggers = list.querySelectorAll('[data-faq-trigger]');

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;

      // Close every other item in this accordion instance.
      triggers.forEach(function (otherTrigger) {
        if (otherTrigger === trigger) return;

        otherTrigger.setAttribute('aria-expanded', 'false');

        var otherPanelId = otherTrigger.getAttribute('aria-controls');
        var otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
        if (otherPanel) {
          otherPanel.style.gridTemplateRows = '0fr';
        }
      });

      // Toggle the clicked item.
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) {
        panel.style.gridTemplateRows = isOpen ? '0fr' : '1fr';
      }
    });
  });
});
